import { isPickupSpot, isPublicFarmStand, productMatchesFarmStand } from "./farmStandPublic";

export const getProductStandLinkId = (product = {}) =>
  product.standId ||
  product.farmStandId ||
  product.pickupSpotId ||
  product.pickupLocationId ||
  product.linkedStandId ||
  product.linkedPickupSpotId ||
  "";

export const isSellerEligibleProductStand = (stand = {}, ownerId = "") => {
  if (!ownerId) return false;

  const ownerMatches = stand.ownerId === ownerId || stand.userId === ownerId;

  return (
    ownerMatches &&
    isPublicFarmStand(stand) &&
    stand.isPublic !== false &&
    stand.visibility !== "private"
  );
};

export const getEligibleProductStands = (stands = [], ownerId = "") =>
  stands.filter((stand) => isSellerEligibleProductStand(stand, ownerId));

const cleanLocationPart = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const sameLocationPart = (left, right) => {
  const cleanLeft = cleanLocationPart(left);
  const cleanRight = cleanLocationPart(right);
  return Boolean(cleanLeft && cleanRight && cleanLeft === cleanRight);
};

export const hasLegacyStandLocationSnapshot = (product = {}) => {
  if (!getProductStandLinkId(product)) return false;

  const productLocation = product.location || {};
  const copiedStandLocation = Boolean(
    product.standLocationText ||
      product.standCity ||
      product.standState ||
      product.standLat ||
      product.standLng
  );

  if (!copiedStandLocation) return false;

  const cityMatches = sameLocationPart(product.city || productLocation.city, product.standCity);
  const stateMatches = sameLocationPart(product.state || productLocation.state, product.standState);
  const textMatches = sameLocationPart(
    product.locationText || productLocation.locationText || productLocation.label,
    product.standLocationText
  );

  return textMatches || (cityMatches && stateMatches);
};

export const shouldClearLegacyStandLocationSnapshot = ({
  existingProduct = {},
} = {}) => {
  return hasLegacyStandLocationSnapshot(existingProduct);
};

export const buildProductStandLinkPayload = ({
  selectedStand = null,
  showOnLiveShelf = false,
} = {}) => {
  if (!selectedStand?.id) {
    return {
      pickupAvailable: false,
      standId: "",
      farmStandId: "",
      pickupSpotId: "",
      linkedStandId: "",
      linkedPickupSpotId: "",
      showOnLiveShelf: false,
      showOnStand: false,
      fulfillmentType: "",
      standName: "",
      standLocationText: "",
      standCity: "",
      standState: "",
      standHoursText: "",
      standPaymentMethods: [],
    };
  }

  const selectedStandIsPickup = isPickupSpot(selectedStand);
  const visibleOnShelf = Boolean(showOnLiveShelf);

  return {
    pickupAvailable: true,
    standId: selectedStand.id,
    farmStandId: selectedStandIsPickup ? "" : selectedStand.id,
    pickupSpotId: selectedStandIsPickup ? selectedStand.id : "",
    linkedStandId: "",
    linkedPickupSpotId: "",
    showOnLiveShelf: visibleOnShelf,
    showOnStand: visibleOnShelf,
    fulfillmentType: selectedStandIsPickup ? "pickup_spot" : "farm_stand",
    standName: selectedStand.standName || selectedStand.name || "",
    standLocationText: "",
    standCity: "",
    standState: "",
    standHoursText: "",
    standPaymentMethods: [],
  };
};

export const productUsesStandLink = productMatchesFarmStand;
